import React from "react"

import { useFormikContext } from "formik"

import { SelectOption } from "~tailwindui/types/SelectOption"

import { timezoneOptions } from "src/enums"

import DisplayableFormikForm from "components/OrganizationAdmin/components/DisplayableFormikForm"
import InlineCalendar from "components/OrganizationAdmin/components/DisplayableFormikForm/InlineCalendar"

const ExportForm = () => {
  const { values } = useFormikContext()
  const formValues: any = values

  return (
    <>
      <input name="focus-hack" className="absolute top-[-100%]" />
      <InlineCalendar
        range
        startFieldName="startingAt"
        endFieldName="endingAt"
        label="Date Range"
        description={
          <>
            <span className="block">
              {formValues.startingAt?.format("M/D/YY")}&nbsp;&mdash;&nbsp;
              {formValues.endingAt?.format("M/D/YY")}
            </span>

            <span className="block">
              Select a start and end date for your export
            </span>
          </>
        }
        value={[formValues.startingAt?.toDate(), formValues.endingAt?.toDate()]}
      />
      <DisplayableFormikForm.SingleSelect
        label="Time Zone"
        name="timezone"
        options={timezoneOptions as SelectOption[]}
        description=""
        portal
        inputWrapperClassNames="col-span-2"
      />
    </>
  )
}

export default ExportForm
